import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { APIURL } from '../app-routing.module';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import * as jwt from "jsonwebtoken";
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class AuthenticationService extends AppService<any>{
  dashFrame: any;
  constructor(protected http: HttpClient, protected router: Router) {
    super(http);
    this.appmod = "login";
  }

  setDashFrame(dashFrame) {
    console.log('in dashframe')
    console.log(dashFrame)
    this.dashFrame = dashFrame
  }

  logout() {
    console.log('In Logout')
    // this.dashFrame.nativeElement.contentWindow.postMessage({
    //   logout: true
    // }, `http://dev.ninjadialer.com/`)

    //this.dashFrame.nativeElement.src = `${environment.SISENSESERVER}/api/auth/logout`;
    if (this.dashFrame && this.dashFrame.nativeElement) {
      this.dashFrame.nativeElement.src = `${environment.SISENSESERVER}/api/auth/logout`;
    }
    this.http.get(APIURL + "login").subscribe(res => {
      sessionStorage.clear();
      // sessionStorage.clear();
      console.log("User Logged Out Successfully");
      location.reload(true);
    },
      err => {
        sessionStorage.clear();
        // sessionStorage.clear();
        console.log("User Logged Out Successfully");
        location.reload(true);
      });
  }
  public getreleasenot(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getreleasenot";
    let saveusers = this.getService(type);
    this.appmod = tmp;
    return saveusers;
  }

  public getUsers(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getusers";
    let saveusers = this.saveService(type);
    this.appmod = tmp;
    return saveusers;
  }

   public getOnboardingUsersStatus(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getOnboardingUsersStatus";
    let saveusers = this.saveService(type);
    this.appmod = tmp;
    return saveusers;
  }



  public get_business(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_business";
    let saveusers = this.getService();
    this.appmod = tmp;
    return saveusers;
  }

  public updatePhoneNumber(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/updatePhoneNumber";
    let saveusers = this.saveService(type);
    this.appmod = tmp;
    return saveusers;
  }

  public resendEmail(emailAddress: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/resendEmail";
    let saveusers = this.saveService(emailAddress);
    this.appmod = tmp;
    return saveusers;
  }

  public updateUserAddress(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/updateUserAddress";
    let saveusers = this.saveService(type);
    this.appmod = tmp;
    return saveusers;
  }

  public aiSetupBuss(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/aiSetupBuss";
    let saveusers = this.saveService(type);
    this.appmod = tmp;
    return saveusers;
  }

  public updateDid(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/updateDid";
    let saveusers = this.saveService(type);
    this.appmod = tmp;
    return saveusers;
  }

  public get_business_type(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_business_type";
    let saveusers = this.getService(type);
    this.appmod = tmp;
    return saveusers;
  }

  ai_setup(data:any): Observable<any>{
    let tmp = this.appmod;
    this.appmod = "custom/ai_data";
    let saveusers = this.getService(data);
    this.appmod = tmp;
    return saveusers;
  }

  public getUserStatus(data:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getUserStatus";
    let saveusers = this.saveService(data);
    this.appmod = tmp;
    return saveusers;
  }

  public updateEmailStatus(data:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/updateEmailStatus";
    let saveusers = this.saveService(data);
    this.appmod = tmp;
    return saveusers;
  }

  public getTokenLogin(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getTokenLogin";
    let data = this.getService();
    this.appmod = tmp;
    return data;
  }
  /* logout()
  {
    this.http.get(APIURL+"login").subscribe(res=>{
      sessionStorage.clear();
      sessionStorage.clear();
      console.log("User Logged Out Successfully");
      location.reload(true);
    },
    err=>{
      sessionStorage.clear();
      sessionStorage.clear();
      console.log("User Logged Out Successfully");
      location.reload(true);
    });
  }
 */
  forgotpass(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/forgotpwd';
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }

  //Registration data post
  Registration(data: any): Observable<any> {
    console.log("Registration Service");
    let tmp = this.appmod;
    this.appmod = 'custom/registration';
    let result = this.saveService(data);
    this.appmod = tmp;
    return result;
  }


  VMUsersLogin(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/vmuserslogin';
    let result = this.saveService(sdata);
    this.appmod = tmp;
    return result;
  }

  getAppPermissions(type: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/app_permissions';
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  getEntityType(sdata:any): Observable<any> {
    console.log("sdata brand",sdata);

    let tmp = this.appmod;
    this.appmod = 'pluginapi/getentity';
    let data = this.getService(sdata);
    this.appmod = tmp;
    return data;
  }

  getAgentdata(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/agentData';
    let data = this.getService();
    this.appmod = tmp;
    return data;
  }

   // VM Login for SSO
   VMSSOLogin(sdata: any): Observable<any> {
    return this.http.post<any>(environment.VMSSO, sdata, {
      headers: {
        "Content-Type": "application/json"
      }
    })
  }

  SwitchAccount() {
    let tmp = this.appmod;
    this.appmod = 'custom/switchagencylogin';
    this.saveService({ id: 1 }).subscribe(ress => {
      this.appmod = tmp;
      console.log(JSON.stringify(ress));
      let rs = ress.login;
      sessionStorage.setItem('isLoggedin', "true");
      sessionStorage.setItem('userid', rs.id);
      sessionStorage.setItem('type', rs.type);
      sessionStorage.setItem('fullname', rs.first_name + " " + rs.last_name);
      sessionStorage.setItem('firstname', rs.first_name);
      sessionStorage.setItem('minutes', rs.minutes);
      sessionStorage.setItem('email', rs.email);
      sessionStorage.setItem('token', rs.authkey);
      sessionStorage.setItem('exten', rs.exten);
      sessionStorage.setItem('password', rs.ext_password);
      sessionStorage.setItem('allcampaign', JSON.stringify(ress.allcamp));
      sessionStorage.setItem('id_campaign', (1).toString());
      sessionStorage.setItem("pkgamount", (0).toString());
      sessionStorage.setItem("profile_image", rs.profile_image);
      sessionStorage.setItem("id_package", rs.id_package);
      sessionStorage.setItem("totalagents", rs.total_agents);
      sessionStorage.setItem("buy_minutes", rs.buy_minutes);
      sessionStorage.setItem("did_credit", rs.did_credit);
      sessionStorage.setItem("id_company", rs.id_company);
      sessionStorage.setItem("manager_id", rs.manager_id);
      sessionStorage.setItem("totalcallattempts", (0).toString());
      sessionStorage.setItem("loadlead", (0).toString());
      sessionStorage.setItem("idparent", rs.idparent);
      sessionStorage.setItem("domain", rs.domain);
      sessionStorage.setItem("sms", rs.sms);
      sessionStorage.setItem("voicemail", rs.voicemail);
      sessionStorage.setItem("isrefreshlead", (1).toString());
      sessionStorage.setItem("issms", "no");
      sessionStorage.setItem("usercamp", rs.campaign);
      sessionStorage.setItem("ispkg", (0).toString());
      sessionStorage.setItem("agent", rs.is_agent);
      sessionStorage.setItem("isreport", ress.dashboard);

      if (parseInt(ress.dashboard) == 1)
        this.ssoLogin(rs.email);
      else
        this.router.navigate(['/dashboards/dashboard6'])
          .then(() => {
            location.reload(true);
          });
    }, err => {

      alert("You have Something wrong in Agency Account.Please Contact to Admin.");
      /* this.snackBar.open("Invalid Username/Password.", "Login", {
        duration: 2000
      }); */
      //window.location.href="http://sfgvirtualmentor.com";
      //this.router.navigate ( [ '/mortgage' ] );
    });
  }

  Movetovirtualmentor() {
    let tmp = this.appmod;
    this.appmod = 'custom/movetovirtualmentor';
    this.saveService({ id: 1 }).subscribe(ress => {
      this.appmod = tmp;
      window.location.href = "http://sfgvirtualmentor.com";
    }, err => {
      window.location.href = "http://sfgvirtualmentor.com";
      /* this.snackBar.open("Invalid Username/Password.", "Login", {
        duration: 2000
      }); */
      //
      //this.router.navigate ( [ '/mortgage' ] );
    });
  }


  SwitchSupervisor() {
    let tmp = this.appmod;
    this.appmod = 'custom/switchsupervisorlogin';
    this.saveService({ id: 1 }).subscribe(ress => {
      this.appmod = tmp;
      console.log(JSON.stringify(ress));
      let rs = ress.login;
      sessionStorage.setItem('isLoggedin', "true");
      sessionStorage.setItem('userid', rs.id);
      sessionStorage.setItem('type', rs.type);
      sessionStorage.setItem('fullname', rs.first_name + " " + rs.last_name);
      sessionStorage.setItem('firstname', rs.first_name);
      sessionStorage.setItem('minutes', rs.minutes);
      sessionStorage.setItem('email', rs.email);
      sessionStorage.setItem('token', rs.authkey);
      sessionStorage.setItem('exten', rs.exten);
      sessionStorage.setItem('password', rs.ext_password);
      sessionStorage.setItem('allcampaign', JSON.stringify(ress.allcamp));
      sessionStorage.setItem('id_campaign', (1).toString());
      sessionStorage.setItem("pkgamount", (0).toString());
      sessionStorage.setItem("profile_image", rs.profile_image);
      sessionStorage.setItem("id_package", rs.id_package);
      sessionStorage.setItem("totalagents", rs.total_agents);
      sessionStorage.setItem("buy_minutes", rs.buy_minutes);
      sessionStorage.setItem("did_credit", rs.did_credit);
      sessionStorage.setItem("id_company", rs.id_company);
      sessionStorage.setItem("manager_id", rs.manager_id);
      sessionStorage.setItem("totalcallattempts", (0).toString());
      sessionStorage.setItem("loadlead", (0).toString());
      sessionStorage.setItem("idparent", rs.idparent);
      sessionStorage.setItem("domain", rs.domain);
      sessionStorage.setItem("sms", rs.sms);
      sessionStorage.setItem("voicemail", rs.voicemail);
      sessionStorage.setItem("isrefreshlead", (1).toString());
      sessionStorage.setItem("issms", "no");
      sessionStorage.setItem("usercamp", rs.campaign);
      sessionStorage.setItem("ispkg", (0).toString());
      sessionStorage.setItem("agent", rs.is_agent);
      sessionStorage.setItem("isreport", ress.dashboard);
      if (ress.allcamp[0].mgmid != null && ress.allcamp[0].mgmid != undefined)
        sessionStorage.setItem("ismgm", 'yes');
      //this.router.navigate(['/dashboards/dashboard1'])


      if (parseInt(ress.dashboard) == 1)
        this.ssoLogin(rs.email);
      else
        this.router.navigate(['/dashboards/dashboard6'])
          .then(() => {
            location.reload(true);
          });
    }, err => {

      alert("You have Something wrong in Supervisor Account.Please Contact to Admin.");
      /* this.snackBar.open("Invalid Username/Password.", "Login", {
        duration: 2000
      }); */
      //window.location.href="http://sfgvirtualmentor.com";
      //this.router.navigate ( [ '/mortgage' ] );
    });
  }

  ssoLogin(email: string) {

    const serverUrl = environment.SISENSESERVER
    const jwtKey = environment.SSOKEY
    console.log(jwtKey);
    console.log(uuidv4());
    console.log(2);
    const playload = {
      sub: email,
      jti: uuidv4()
    }

    const token = jwt.sign(playload, jwtKey, {
      algorithm: "HS256"
    })

    let finalUrl = `${serverUrl}/jwt?jwt=${token}`
    window.location.href = finalUrl
  }

  QuilityLogin(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/quilitylogin';
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }

  PluginSignup(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/pluginsignup';
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }

  // @avalara authentication
  // AvaGetAuth(sdata: any): Observable<any> {
  //   let url: string = "https://tax.ninjadialer.com/login"
  //   return this.http.post<any>(url, sdata)
  // }

  AvaGetAuth(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/tax_authentication';
    let data = this.saveService({
      data:sdata,
      url:"https://tax.ninjadialer.com/login"
      // url: "http://localhost/avatax/php/trunk/login"
    });
    this.appmod = tmp;
    return data;
  }

  // @avalara make calculation
  // AvaTaxCalc(sdata: any, header: any = null): Observable<any> {
  //   let url: string = "https://tax.ninjadialer.com/charges/cal_taxaxtion"
  //   return this.http.post<any>(url, sdata, {
  //     headers: {
  //       "Content-Type": "application/json"
  //     }
  //   })
  // }

  AvaTaxCalc(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/tax_calculation';
    let data = this.saveService({
      data:sdata,
      url:"https://tax.ninjadialer.com/charges/cal_taxaxtion"
      // url: "http://localhost/avatax/php/trunk/charges/cal_taxaxtion"
    });
    this.appmod = tmp;
    return data;
  }

  AvaTaxCommit(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/tax_calculation';
    let data = this.saveService({
      data:sdata,
      url:"https://tax.ninjadialer.com/charges/commit_tax_transactions"
      // url: "http://localhost/avatax/php/trunk/charges/commit_tax_transactions"
    });
    this.appmod = tmp;
    return data;
  }

  GetBillingDetails(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/billingdetails';
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  ApplyStripeCoupon(pdata:any):Observable<any>
  {
     let tmp=this.appmod;
     this.appmod="pluginapi/applystripecoupon";
     let data=super.saveService(pdata);
     this.appmod=tmp;
     return data;
  }


  getPaymentService(type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'payment';
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @buy package
  buyPackage(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/buy_package';
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }

  // @update role permission
  UpdateRolePermission(sdata: any, authkey: any): Observable<any> {
    return this.http.post<any>(APIURL + 'pluginapi/update_role_permission', {
      "data": sdata
    }, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": authkey
      }
    })
  }


  /**
   * VM checkout process
   */
  buyVMPackage(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/buy_vmpackage';
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }


  /**
   * VM panel package purchase/upgrade
   */
  buyVMPackagePanel(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'pluginapi/buy_vmpackage_panel';
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }


  /**
   * VM session login update
   */
  SessionLogin(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'sessionlogin';
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  //  Reset password
  public update_Password(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'login/resetpassword';
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }

}
